import React, { useState, useRef,useEffect } from "react";
import { Link } from "react-router-dom";
import UserPool from "UserPool";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Images from "../../assets/images/imageData";
import UserProfile from "./UserProfile";
import "./header.scss";
const Header = ({
  onClickReadAll,
  notificationsList,
  activeComponent,
  user,
  isUserProfile = false,
  isBack = false,
  getBackPath,
  pageName="",
  showSide=false,
}) => {
  const [userName, setUserName] = useState(localStorage.getItem('email'));
  const [isShow, setIsShow] = useState(false);
  const [isNotificationsShow, setIsNotificationsShow] = useState(false);
  const useDtl = useRef(null);
  const notificationsOpen = useRef(null);
  const [cartList, setCartList] = useState([]);

  useEffect(()=>{
    if(showSide===true){
      document.body.classList.add("show-sidebar");
    }else{
      document.body.classList.remove("show-sidebar");
    }
  },[showSide]);

  const handleLogout = () => {
    let elem = document.getElementById("search_current_location");
    if (elem) {
      elem.parentNode.removeChild(elem);
    }
  
    const cognitoUser = UserPool.getCurrentUser();   
    if (cognitoUser !== null) {
     cognitoUser.signOut();
     localStorage.setItem("logout", "yes");
      localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.idToken");
      localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.accessToken");
      localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.refreshToken");
      localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.rajeev.clockDrift");
      localStorage.removeItem("CognitoIdentityServiceProvider.7crnf0pbvktbhdf878b5cobn5n.LastAuthUser");
      localStorage.removeItem("token");
      localStorage.removeItem("email"); 
      // sessionService.deleteSession();
      // sessionService.deleteUser();
      sessionStorage.clear();
      window.location.href="/login";
    }
  };

  const handleOutsideClick = (e) => {
    if (!useDtl.current.contains(e.target)) {
      setIsShow(false);
    }
    if (!notificationsOpen.current.contains(e.target)) {
      setIsNotificationsShow(false);
    }
  };

  const handleNotifications = async () => {
    onClickReadAll();
    setIsNotificationsShow(!isNotificationsShow);
  };

  return (
    <>
      <header className="partner main-header">
        <div className="logo">
          <span
            className="head-col sidebar-hamburger"
            onClick={() => document.body.classList.toggle("show-sidebar")}
          >
            <img src={Images?.hamburger} alt="icon" />
          </span>
          <Link to="/home" className="head-col">
            <picture>
              <source media="(min-width:768px)" srcSet={Images?.logo} />
              <img src={Images?.logo} alt="Logo" width="99" />
            </picture>
          </Link>
        </div>
        <nav>
          <div style={{display: "flex"}}>
             <span className="admin-icon">
                <img src={Images?.admin} alt="icon" />
              </span>
            <NavDropdown title={userName} id="basic-nav-dropdown">
              <NavDropdown.Item href="" onClick={handleLogout}>Logout </NavDropdown.Item>
            </NavDropdown>
            </div>
        </nav>
      </header>
      <header>
        <div className="partner mobile-header">
          {isBack ? (
            <div className="logo">
              <span
                className="head-col sidebar-hamburger"
                onClick={getBackPath}
              >
                <img src={Images?.backArrow} alt="icon" />
              </span>
            </div>
          ) : (
            <div className="logo">
              <span
                className="head-col sidebar-hamburger"
                onClick={() => document.body.classList.toggle("show-sidebar")}
              >
                <img src={Images?.hamburger} alt="icon" />
              </span>
            </div>
          )}

          <div className="logo">
            <Link to="/home" className="head-col company">
              <picture>
                <source media="(min-width:768px)" srcSet={Images?.logo} />
                <img src={Images?.logo} alt="Logo" width="75" />
              </picture>
            </Link>
            <Link to="#" className="head-col">
              <picture>
                <source media="(min-width:768px)" srcSet={Images?.logo} />
                <img src={Images?.partner} alt="Logo" width="75" />
              </picture>
            </Link>
          </div>
          <nav>
            <ul>
              {activeComponent === "brand-activation" && (
                <li className="treeview nav-li cart">
                  <Link
                    to={
                      cartList?.length > 0
                        ? "/dashboard/brand-activation/checkout"
                        : "#"
                    }
                  >
                    <img src={Images?.CartIcon} alt="icon" />
                    {cartList?.length > 0 && (
                      <span className="notifications-count">
                        {cartList?.length}
                      </span>
                    )}
                  </Link>
                </li>
              )}
              <li
                ref={notificationsOpen}
                className="treeview nav-li notification"
              >
                <Link to="#" onClick={handleNotifications}>
                  <img src={Images?.notification} alt="icon" />
                </Link>
                <ul
                  className={`treeview-menu scrollbar-styling notifications-list ${
                    isNotificationsShow ? "d-block" : ""
                  }`}
                >
                  {notificationsList && notificationsList.length > 0 ? (
                    notificationsList.map((item, ind) => {
                      return (
                        <li key={ind}>
                          <Link to="#">{item.notification_text}</Link>
                        </li>
                      );
                    })
                  ) : (
                    <li>
                      <Link to="#" className="no-notification">
                        No Notifications
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
              <li className="treeview nav-li notification">
                <Link to="#" onClick={handleNotifications}>
                  <img src={Images?.blackInfo} alt="icon" />
                </Link>
              </li>
              <li className="treeview nav-li notification">
                <Link to="#" onClick={handleNotifications}>
                  <img src={Images?.phone} alt="icon" />
                </Link>
              </li>
              <li
                ref={useDtl}
                className={`treeview nav-li admin-menu ${
                  isShow ? "dropdown-open" : ""
                }`}
              ></li>
            </ul>
          </nav>
        </div>
        {isUserProfile ? <UserProfile userName={user?.name} pageName={pageName} /> : null}
      </header>
    </>
  );
};
export default Header;
